import React from 'react';
import { PaccProfileResultVO } from '@domain/vo/phs/pacc/competence/PaccProfileResultVO';
import { competenceProfileMap } from '@domain/constant/competenceType';
import classNames from 'classnames/bind';
import styles from './competencyHacks.module.scss';

const cx = classNames.bind(styles);

interface CompetencyHacksProps {
  paccProfileResult: PaccProfileResultVO;
}

const CompetencyHacks = ({ paccProfileResult }: CompetencyHacksProps) => {
  const { standOutComment, cautionComment, name } = competenceProfileMap[paccProfileResult.type];

  return (
    <div className={cx('contentWrap')}>
      <em className={cx('title')}>
        {name}을 위한 <span className={cx('emphasis')}>직장생활 꿀팁</span>
      </em>

      <div className={cx('descArea')}>
        <em className={cx('title')}>{`${name}이 직장에서 빛나는 순간!`}</em>
        <p className={cx('desc')}>{standOutComment}</p>
      </div>

      <div className={cx('descArea', 'tip')}>
        <em className={cx('title')}>이것까지 챙기면 직장생활 만렙</em>
        <p className={cx('desc')}>{cautionComment}</p>
      </div>
    </div>
  );
};

export default CompetencyHacks;
